import { useState, useEffect, useCallback } from 'react'
import { listSnapshots, rollbackSnapshot } from '../api/vestige.js'

export function useSnapshots(workspaceId) {
  const [snapshots, setSnapshots] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [rollingBack, setRollingBack] = useState(null)

  const fetch = useCallback(async () => {
    if (!workspaceId) return
    setLoading(true)
    setError(null)
    try {
      const data = await listSnapshots(workspaceId)
      // Sort newest first
      const sorted = [...data].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      )
      setSnapshots(sorted)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }, [workspaceId])

  useEffect(() => {
    fetch()
  }, [fetch])

  const append = useCallback((snapshot) => {
    setSnapshots((prev) => {
      const exists = prev.some((s) => s.id === snapshot.id)
      if (exists) {
        return prev.map((s) => (s.id === snapshot.id ? snapshot : s))
      }
      return [snapshot, ...prev]
    })
  }, [])

  const rollback = useCallback(
    async (snapshotId) => {
      setRollingBack(snapshotId)
      try {
        const result = await rollbackSnapshot(workspaceId, snapshotId)
        setSnapshots((prev) => [result, ...prev])
        return result
      } catch (err) {
        throw new Error(err.message)
      } finally {
        setRollingBack(null)
      }
    },
    [workspaceId]
  )

  return { snapshots, loading, error, refresh: fetch, append, rollback, rollingBack }
}
